import { message } from "antd";
import {
  GALLERY_IMAGE_UPLOAD_REQUEST,
  GALLERY_IMAGE_UPLOAD_SUCCESS,
  GALLERY_IMAGE_UPLOAD_FAIL,
  GALLERY_IMAGE_FETCH_REQUEST,
  GALLERY_IMAGE_FETCH_SUCCESS,
  GALLERY_IMAGE_FETCH_FAIL,
  GALLERY_IMAGE_DELETE_REQUEST,
  GALLERY_IMAGE_DELETE_SUCCESS,
  GALLERY_IMAGE_DELETE_FAIL,
} from "../../constants/admin/galleryConstants";
import axios from "../../../axiosInstance";

// Upload Gallery Images
export const uploadGalleryImage = (images) => async (dispatch) => {
  try {
    dispatch({ type: GALLERY_IMAGE_UPLOAD_REQUEST });

    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image);
    });

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const { data } = await axios.post(
      "/api/v1/gallery-image/upload",
      formData,
      config
    );

    if (data?.success === true) {
          dispatch({ type: GALLERY_IMAGE_UPLOAD_SUCCESS, payload: data });
          message.success(data?.message || "Gallery images added successfully");
        } else {
          throw new Error(data?.message || "Failed to Gallery images");
        }
  } catch (error) {
    dispatch({
      type: GALLERY_IMAGE_UPLOAD_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to gallery images"
    );
  }
};

// Fetch Gallery Images 
export const fetchGalleryImages = () => async (dispatch) => {
  try {
    dispatch({ type: GALLERY_IMAGE_FETCH_REQUEST });

    const { data } = await axios.get("/api/v1/gallery-image/get");

    dispatch({ type: GALLERY_IMAGE_FETCH_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GALLERY_IMAGE_FETCH_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};

// Delete gallery Image
export const deleteGalleryImage = (publicId) => async (dispatch) => {
  try {
    dispatch({ type: GALLERY_IMAGE_DELETE_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.delete("/api/v1/gallery-image/delete", {
      data: { publicId },
      ...config,
    });
    if (data?.success === true) {
      dispatch({ type: GALLERY_IMAGE_DELETE_SUCCESS, payload: data });
      message.success(data?.message || "Gallery image deleted successfully");
    } else {
      throw new Error(data?.message || "Failed to gallery images");
    }
  } catch (error) {
    dispatch({
      type: GALLERY_IMAGE_DELETE_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to gallery images"
    );
  }
};
